
import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import * as agui from 'arm-gui/dist/controls';
import I18nActions from './i18n_actions'

import { i18n } from 'arm-common';

class CreateI18N extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[CreateI18N.jsx] ';
        this.salvaI18N = this.salvaI18N.bind(this);
        this.salvaOnClick = this.salvaOnClick.bind(this);
        this.cancelEdit = this.cancelEdit.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.arrayChangeHandler = this.arrayChangeHandler.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.state = {
            validation: new Map(),
            showConfirm: false,
            i18n: [],
        };
    }

    cancelEdit() {
        if (this.props.location.state && this.props.location.state.modifica) {
            this.props.cancelEdit();
            this.props.history.push({ pathname: '/impostazioni/localizzazioneDetails', state: { id: this.props.location.state.id } });
        } else {
            this.props.history.goBack();
        }

    }

    showConfirmPanel() {
        this.setState({ showConfirm: !this.state.showConfirm })
        // $("#modalConfirm").modal("show");
    }


    salvaOnClick() {
        console.log(this.componentName + 'salvaOnClick');
        if (!this.validateForm()) {
            console.log('validateForm return false');
            return;
        }

        this.showConfirmPanel();

    }

    validateForm() {
        let validation = new Map();
        let required = ['code'];
        // for (let i = 0; i < required.length; i++) {
        if (this.props.i18n.code === undefined || this.props.i18n.code === '' || this.props.i18n.code === null) {
            validation.set(required[0], i18n('ARM_CORE_PRINT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            // }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        //   $("#modalConfirm").modal("close");
        this.setState({ showConfirm: !this.state.showConfirm })
        return false;
    }

    salvaI18N() {
        if (!this.validateForm()) {
            console.log('validateForm return false');
            return;
        }

        if (this.props.location.state && this.props.location.state.modifica) {
            this.props.salvaI18N(this.props.history, true);
        } else {
            this.props.salvaI18N(this.props.history, false);
        }

    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        if (!this.props.location.state || !this.props.location.state.modifica) {
            // this.props.clearAll();
        }


        if (this.props.location.state && this.props.location.state.modifica) {
            this.props.inizilizzaModificaI18n(this.props.location.state.id);
        } else {
            this.props.newI18N();
        }
    }

    arrayChangeHandler(e, lang) {
        // updateI18n
        console.log(this.componentName + 'arrayChangeHandler [index] ' + e.target.id + "[Lang] " + lang);


        let value = e.target.value;
        let index = e.target.id;

        this.props.updateI18n(index, value);
        // this.setState({ i18n: this.props.i18n })

        return;

    }

    inputChangeHandler(e, index) {
        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;

            this.setState({ i18n: this.props.i18n })
            this.props.handleChange(id, value);
        }
    }


    render() {
        console.log(this.componentName + 'render');
        return (
            <div>
                <agui.aCard>
                    <agui.aCardHeader>
                        {this.props.location.state && this.props.location.state.modifica ?

                            <h3>{i18n('ARM_CORE_PRINT.LOCALIZZAZIONE.MODIFICA_DEL_I18N', 'Modifica del i18n')} {this.props.location.state.id}</h3>
                            :
                            <h3>{i18n('ARM_CORE_PRINT.LOCALIZZAZIONE.CREAZIONE_NUOVO_I18N', 'Creazione Nuovo I18n')}</h3>
                        }
                    </agui.aCardHeader>

                    <agui.aCardBody>
                        <div>
                            {!this.props.location.state || !this.props.location.state.modifica ?
                                <agui.CoolTextInput id="code"
                                    value={this.props.i18n.code}
                                    placeholder={i18n('ARM_CORE_PRINT.SHARED.INSERIRE_CODICE', 'inserire codice')}
                                    label={i18n('ARM_CORE_PRINT.SHARED.CODICE_ASTERISK', 'Codice*')}
                                    validation={this.state.validation}
                                    onChange={(value) => this.inputChangeHandler(
                                        {
                                            target: {
                                                value: value,
                                                id: "code",
                                            }
                                        }
                                    )} />
                                : null
                            }


                            <table className="table table-bordered" >
                                <thead>
                                    <tr>
                                        <td>{i18n('ARM_CORE_PRINT.SHARED.INDEX', 'Index')}</td>
                                        <td>{i18n('ARM_CORE_PRINT.SHARED.LINGUA', 'Lingua')}</td>
                                        <td>{i18n('ARM_CORE_PRINT.SHARED.DESCRIZIONE', 'Descrizione')}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.listI18n && this.props.listI18n.map(
                                        (item, index) =>

                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.codLang}</td>
                                                <td>
                                                    <agui.CoolTextInput id={index}
                                                        value={this.props.listI18n && this.props.listI18n && this.props.listI18n[index] ? this.props.listI18n[index].descr : null}
                                                        label=""
                                                        eventParam={item.codLang}
                                                        onChange={(value) => this.arrayChangeHandler({
                                                            target: {
                                                                value: value,
                                                                id: index,
                                                            }
                                                        })} />

                                                </td>
                                            </tr>
                                    )
                                    }
                                </tbody>
                            </table>
                        </div>
                        <br></br>

                    </agui.aCardBody>
                    <agui.aCardFooter>
                        <div>
                            {/* <agui.aButton bs="primary" className="mr-2" icon="fas fa-save" onClick={this.salvaOnClick}>{i18n('ARM_CORE_PRINT.SHARED.SALVA', 'Salva')}</agui.aButton> */}
                            <agui.aButton
                                askConfirm={"Confermi di voler salvare I18n?"}
                                bs="primary"
                                className="mr-2"
                                icon="fas fa-save"
                                onClick={this.salvaI18N}>
                                {i18n('ARM_CORE_PRINT.SHARED.SALVA', 'Salva')}
                            </agui.aButton>
                            <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.cancelEdit}>{i18n('ARM_CORE_PRINT.SHARED.ANNULLA', 'Annulla')}</agui.aButton>
                        </div>
                    </agui.aCardFooter>
                </agui.aCard>
            </div >

        );
    }

};
function mapStateToProps(state) {
    return {
        i18n: state.localizzazione.i18n,
        listI18n: state.localizzazione.i18n.listApLang
    }
}


function mapDispatchToProps(dispatch) {
    return {

        salvaI18N(history, isModifica) {
            return dispatch(I18nActions.salvaI18N(history, isModifica));
        },
        updateI18n(listApLangIndex, descr) {
            return dispatch(I18nActions.updateI18n(listApLangIndex, descr))
        },
        handleChange(index, e) {
            return dispatch(I18nActions.handleChange(index, e))
        },
        newI18N() {
            return dispatch(I18nActions.newI18N());
        },
        inizilizzaModificaI18n(codice) {
            return dispatch(I18nActions.inizilizzaModificaI18n(codice))
        },
        cancelEdit() {
            return dispatch(I18nActions.cancelEdit())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateI18N);
